interface TabPanelProps {
  children?: React.ReactNode;
  className?: string;
  index: number;
  value: number;
}

export default function TabPanel(props: TabPanelProps): JSX.Element {
  const { children, value, index, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={`h-full ${className ?? ""}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
